/* Copyright (C) 2022 ev-i Informationstechnologie GmbH */
import { InjectionKey, inject } from "vue";
import { CdesContext } from "cdes-vue/core/CdesContext";

export const contextKey: InjectionKey<CdesContext> = Symbol("cdes context");

export function useCtx(): CdesContext {
    return inject(contextKey);
}
